/**
 * Shared auth helper.
 * Returns an Authorization header object with a fresh Cognito ID token.
 * Safe to call on every request – Amplify refreshes tokens automatically.
 */
import { fetchAuthSession } from "aws-amplify/auth";

export async function getAuthHeaders() {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString();
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}
